import { render, staticRenderFns } from "./AttachedFiles.vue?vue&type=template&id=678f9f60&scoped=true&"
import script from "./AttachedFiles.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AttachedFiles.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AttachedFiles.vue?vue&type=style&index=0&id=678f9f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f9f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678f9f60')) {
      api.createRecord('678f9f60', component.options)
    } else {
      api.reload('678f9f60', component.options)
    }
    module.hot.accept("./AttachedFiles.vue?vue&type=template&id=678f9f60&scoped=true&", function () {
      api.rerender('678f9f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/AttachedFiles.vue"
export default component.exports